import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import AnalyticsWebClient, { envType, originType, userType } from '@atlassiansox/analytics-web-client';
var ANALYTICS_PRODUCT = 'embeddedConfluence';

// Define default analytic-web-client environment config for now
var getAnalyticsEnv = function getAnalyticsEnv(hostname) {
  if (hostname.includes('localhost')) {
    return envType.LOCAL;
  }
  if (hostname.includes('jira-dev')) {
    return envType.DEV;
  }
  return envType.PROD;
};
var analyticsClient;
var getUserInfo = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostname, userInfo) {
    var prefix, res, resJson, account_id, account_type;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!userInfo) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", {
            userId: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId,
            userIdType: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userIdType
          });
        case 4:
          prefix = "".concat(window.location.protocol, "//").concat(hostname || window.location.hostname);
          _context.next = 7;
          return fetch("".concat(prefix, "/gateway/api/me"));
        case 7:
          res = _context.sent;
          _context.next = 10;
          return res.json();
        case 10:
          resJson = _context.sent;
          account_id = resJson.account_id, account_type = resJson.account_type;
          return _context.abrupt("return", account_type === 'atlassian' ? {
            userId: account_id,
            userIdType: userType.ATLASSIAN_ACCOUNT
          } : undefined);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUserInfo(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var getAnalyticsWebClient = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
    var hostname, userInfo, fetchedUserInfo;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          hostname = _ref2.hostname, userInfo = _ref2.userInfo;
          if (analyticsClient) {
            _context2.next = 13;
            break;
          }
          analyticsClient = new AnalyticsWebClient({
            product: ANALYTICS_PRODUCT,
            env: getAnalyticsEnv(hostname || window.location.hostname),
            origin: originType.WEB
          });
          _context2.prev = 3;
          _context2.next = 6;
          return getUserInfo(hostname, userInfo);
        case 6:
          fetchedUserInfo = _context2.sent;
          if (fetchedUserInfo) {
            analyticsClient.setUserInfo(fetchedUserInfo.userIdType, fetchedUserInfo.userId);
          }
          _context2.next = 13;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](3);
          // eslint-disable-next-line no-console
          console.error("Error fetching userInfo from ".concat(hostname, "/gateway/api/me"));
        case 13:
          return _context2.abrupt("return", analyticsClient);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[3, 10]]);
  }));
  return function getAnalyticsWebClient(_x3) {
    return _ref3.apply(this, arguments);
  };
}();